import { Link } from "react-router-dom";
import { Lock, Clock } from "lucide-react";

export default function ClosedBanner({ availability, small = false }) {
  if (!availability || availability.accepting_orders) return null;
  const Icon = availability.reason_code === "CLOSED_HOURS" ? Clock : Lock;
  return (
    <div className={`rounded-2xl border ${small ? "p-3" : "p-4"} border-red-200 bg-red-50 text-red-800`} data-testid="closed-banner">
      <div className="flex items-start gap-2">
        <Icon className="mt-0.5 shrink-0" size={small ? 18 : 22}/>
        <div>
          <div className="font-extrabold">{availability.reason}</div>
          {availability.sub_reason && <div className="text-sm text-red-700 mt-0.5">{availability.sub_reason}</div>}
        </div>
      </div>
    </div>
  );
}

export function ClosedPage({ availability, restaurant }) {
  return (
    <div className="min-h-screen brand-soft grid place-items-center px-5">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 rounded-3xl bg-red-100 text-red-600 grid place-items-center mx-auto"><Lock size={36}/></div>
        <h1 className="mt-4 text-2xl font-extrabold" data-testid="closed-title">{availability.reason}</h1>
        {availability.sub_reason && <p className="mt-2 text-gray-700">{availability.sub_reason}</p>}
        {restaurant && <div className="mt-4 text-sm text-gray-500">{restaurant.name}</div>}
        <Link to="/" className="mt-6 inline-flex pill bg-white border border-orange-200 text-orange-700 px-5 py-3 font-bold">العودة للرئيسية</Link>
      </div>
    </div>
  );
}
